<div class="ticker-container" #tickerContainer>
	<span class="ticker-text" #tickerText>
	  <ng-content></ng-content>
	</span>
  </div>